import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'daysRemaining',
  standalone: true // Se usi Angular 14+ con Standalone Components
})
export class DaysRemainingPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);
  transform(startDate: Date | string | number, endDate: Date | string | number): SafeHtml {
    if (!startDate || !endDate) return "";

    const start = new Date(startDate).getTime();
    const end = new Date(endDate).getTime();

    // Differenza in millisecondi
    const diffInMs = end - start;

    // Converti i millisecondi in giorni (1000ms * 60s * 60m * 24h)
    const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
    let htmlResult="";
    let classBlink="";
    if(isNaN(diffInDays)){

    }else{
      if(diffInDays>0){
        if(diffInDays<10){
          classBlink="blink alert-danger";
        }

        htmlResult=`<div class="badge border alert-primary ${classBlink}">- ${diffInDays.toString()} gg</div>`;
      }
        
      else
        htmlResult=`<div class="badge border alert-danger">Scaduto</div>`;
    }


    return this.sanitizer.bypassSecurityTrustHtml(htmlResult);

  }
}